import "./ErrorMessageStyle.css";
import React from "react";
import { ErrorIcon } from "../Icons";
import { ERRORS } from "../../types";

type ChatErrorMessageProps = {
  errorMessage: string;
  showMargin?: boolean;
};

export const ErrorMessage = ({ errorMessage, showMargin }: ChatErrorMessageProps) => (
  <div className={`error-message ${showMargin ? "error-message-margin" : ""}`}>
    <div className="icon">
      <ErrorIcon />
    </div>
    <p>{errorMessage || ERRORS.UNEXPECTED}</p>
  </div>
);
